var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"physicalCommodityList"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("商品")]),_c('el-breadcrumb-item',[_vm._v("商品管理")]),_c('el-breadcrumb-item',[_vm._v("素材库")])],1),_c('div',{staticClass:"boxLayout"},[_c('materialLibrary')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }